import React from "react";
import { useState } from "react";
import Styles from "../../Styles/Resume.module.css"
import edit from "../../Assets/edit.png"


const Profile = () => {
    const [workProfile, setWorkProfile] = useState([
      {
        name: 'Babatunde Samuel ',
        location: 'Ibadan 200233',
        email: 'babatundesamuel@gmail.com',
        Number: '+2348134738493',
        
      },
    ]);
  
    const [newWorkProfile, setNewWorkProfile] = useState({
        name: '',
        location: '',
        email: '',
        Number: '',

    });
  
    const handleAddWorkProfile = () => {
      setWorkProfile([...workProfile, newWorkProfile]);
      setNewWorkProfile({
        name: '',
        location: '',
        email: '',
        Number: '',
       
      });
    };
  
    const handleEditWorkProfile = (index) => {
      const updatedWorkProfile = [...workProfile];
      updatedWorkProfile[index] = newWorkProfile;
      setWorkProfile(updatedWorkProfile);
    };
  
    const handleDeleteWorkProfile = (index) => {
      const updatedWorkProfile = [...workProfile];
      updatedWorkProfile.splice(index, 1);
      setWorkProfile(updatedWorkProfile);
    };

    const [modalOpen,  setModalOpen  ] = useState(false)

    const handleCloseModal = () => {
      setModalOpen(false);
    };
   
   
  
    return (
        <div className={Styles.contents1}>
  {workProfile.map((profile, index) => (           
      <><div key={index} className={Styles.text}>
          <h1>{profile.name}</h1>
          <p>{profile.location}</p>
          <p>{profile.email}</p>
          <p>{profile.Number}</p>
      </div><div className={Styles.image}>
              <img src={edit} onClick={() => setModalOpen(true)} alt="/" width="23.0px" height="23.0px" />
          </div></>

         ))}
        

      {modalOpen && <div id={Styles.ModalContainer} >
        <div id={Styles.Modal}  >
        <label>Name</label>
          <input type="text" value={newWorkProfile.name} onChange={(e) => setNewWorkProfile({ ...newWorkProfile, name: e.target.value })} />
          <label>Location</label>
          <input type="text" value={newWorkProfile.location} onChange={(e) => setNewWorkProfile({ ...newWorkProfile, location: e.target.value })} />
          <label>Email Address</label>
          <input type="text" value={newWorkProfile.email} onChange={(e) => setNewWorkProfile({ ...newWorkProfile, email: e.target.value })} />
          <label>Phone Number</label>
          <input type="text" value={newWorkProfile.Number} onChange={(e) => setNewWorkProfile({ ...newWorkProfile, Number: e.target.value })} />
          <button onClick={handleAddWorkProfile} className={Styles.btn1}>Add</button>
            <button onClick={handleCloseModal} className={Styles.btn2}>close</button>
        </div>
        </div>}
            </div>
    );
  }
export default Profile;